import styled from 'styled-components';
import { Link } from 'react-router-dom';

export default styled(Link)`
  border-bottom: none !important;
  :hover {
    text-decoration: none !important;
  }
`;
